var _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrev = function SvgPrev(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.589 38.413 8.175 24 22.589 9.586l2.121 2.121L12.417 24 24.71 36.292z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.739 38.413 19.326 24 33.739 9.586l2.121 2.121L23.568 24 35.86 36.292z"
  })))));
};
export default SvgPrev;